
  const supervisors = {
    path: "/admin/supervisors",
    name: "SupervisorsSetup",
    component: () => import(/* webpackChunkName: "SupervisorsSetup" */ "@/components/settlement/AssignSupervisorAccess.vue"),
    meta: { authorize: ['Administrator', 'Manager'], requiresAuth: true }
  };

export default supervisors;